import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import InputGroup from 'react-bootstrap/InputGroup';
import { Formik } from 'formik';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import UnifyButton from '../../../../components/Button';
import config from '../../../../config';

const AddAdmin = ({
  show, handleClose, setAlert, refetch,
}) => {
  const [input, setInput] = useState({ name: '', username: '', npmnip: '' });
  const submit = async (data) => {
    const resp = await axios.post(`${config.API_BASE_URL}api/account/add-admin/`, data, {
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    if (resp?.data?.Status === 'Success') {
      handleClose();
      setAlert({ type: 'success', message: 'Anda berhasil menambahkan admin' });
    } else {
      handleClose();
      setAlert({ type: 'failed', message: 'Terjadi kesalahan saat menambahkan admin' });
    }
    refetch();
  };

  const change = (e) => {
    const newInput = { ...input };
    newInput[e.target.name] = e.target.value;
    setInput(newInput);
  };
  return (

    <Modal centered show={show} onHide={handleClose}>
      <Formik
        onSubmit={submit}
        validate={(values) => {
          const errors = {};
          if (!values.username) {
            errors.username = 'Mohon diisi';
          } if (!values.name) {
            errors.name = 'Mohon diisi';
          } if (!values.npmnip) {
            errors.npmnip = 'Mohon diisi';
          }
          return errors;
        }}
        initialValues={{
          name: input.name,
          username: input.username,
          npmnip: input.npmnip,
        }}
        validateOnChange={false}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          errors,
        }) => (
          <>
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>Tambah Admin</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group controlId="validationFormik01">
                  <Form.Label>Nama</Form.Label>
                  <InputGroup hasValidation>

                    <Form.Control
                      type="text"
                      name="name"
                      data-testid="name"
                      value={values.name}
                      onChange={(e) => {
                        handleChange(e);
                        change(e);
                      }}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group controlId="validationFormik02">
                  <Form.Label>Username</Form.Label>
                  <InputGroup hasValidation>

                    <Form.Control
                      type="text"
                      name="username"
                      data-testid="username"
                      value={values.username}
                      onChange={(e) => {
                        handleChange(e);
                        change(e);
                      }}
                      isInvalid={!!errors.username}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.username}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <Form.Group controlId="validationFormik03">
                  <Form.Label>NIP</Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type="text"
                      name="npmnip"
                      data-testid="npmnip"
                      value={values.npmnip}
                      onChange={(e) => {
                        handleChange(e);
                        change(e);
                      }}
                      isInvalid={!!errors.npmnip}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.npmnip}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <UnifyButton color="#CED4DA" onClick={handleClose}>
                  Batal
                </UnifyButton>
                <UnifyButton color="#538AC5" type="submit">
                  Buat
                </UnifyButton>
              </Modal.Footer>
            </Form>
          </>
        )}
      </Formik>
    </Modal>
  );
};

AddAdmin.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default AddAdmin;
